var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"0 24px"}},[_c('StatementForm',{attrs:{"source":"QI"}}),_c('exportBtn'),_c('WmsTable',{attrs:{"is-pagination":false,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }